import React, { useEffect, useState } from 'react'
import PosRequestInfo from './pos-request-search-info'
import PosRequestInfoCheck from './pos-request-search-info-checkbox';
import PosRequestTakePolicy from './pos-request-search-take-policy';

function PosRequestSearch({ objectDto, setObjectDto, setLoading, lang, validate, setValidate, reset, setReset }) {

    // field
    const [idNumber, setIdNumber] = useState("");
    const [phone, setPhone] = useState("");
    const [policyNo, setPolicyNo] = useState("");

    useEffect(() => {
        if (reset) {
            setIdNumber('');
            setPhone('');
            setPolicyNo('');
            setReset(false);
        }
    }, [reset]);

    return (
        <div style={objectDto.checked === 1 || objectDto.saved === 1 ? { display: "block", borderBottom: "2px solid #c4960c", marginBottom: "1%" } : { display: "block", marginBottom: "1%" }}>
            <div data-toggle="collapse" data-target="#search-box-1" className={"header-box"} id="search-box-1-header">
                <h2 className="title-box description-large-customer" title="claim.policy.check">
                    {objectDto.checked === 0 ? lang('claimpolicycheck').toUpperCase() : lang('policyinfo').toUpperCase()}
                </h2>
            </div>
            <div className={"collapse in"} id="search-box-1">
                <div className="border-box-sc row" id="policyDiv" style={{ marginBottom: "-10px" }}>
                    {objectDto.checked === 1 || objectDto.saved === 1 ?
                        <PosRequestInfo objectDto={objectDto} lang={lang} validate={validate} setObjectDto={setObjectDto} />
                        :
                        <PosRequestTakePolicy setObjectDto={setObjectDto} policyNo={policyNo} setPolicyNo={setPolicyNo} setLoading={setLoading} />
                    }
                </div>
                {objectDto.checked === 1 || objectDto.saved === 1 ?
                    <PosRequestInfoCheck objectDto={objectDto} setObjectDto={setObjectDto} setLoading={setLoading} lang={lang} setValidate={setValidate} /> : ""}
            </div>
        </div>
    )
}

export default PosRequestSearch